module.exports = __webpack_public_path__ + "img/5.34e9bc5e.png";